import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import AuthShell from './AuthShell';
import { TextField, PasswordField, ErrorBanner } from './fields';

const Signup = () => {
  const { t } = useTranslation();
  const { signup, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!fullName.trim() || !email.trim() || !password) {
      setError(t('auth.error.required'));
      return;
    }
    if (!accepted) {
      setError(t('auth.error.terms'));
      return;
    }

    setError(null);
    setLoading(true);
    try {
      const data = await signup({
        email: email.trim(),
        fullName: fullName.trim(),
        password,
      });
      // Kayıt sonrası backend doğrulama kodu gönderdiyse doğrulama ekranına git.
      if (data?.verifyRequest) {
        navigate('/verify-email', {
          replace: true,
          state: {
            email: email.trim(),
            sessionTimeOut: data.verifyRequest.sessionTimeOut,
          },
        });
      } else {
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow={t('auth.signup.eyebrow')}
      title={t('auth.signup.title')}
      subtitle={t('auth.signup.subtitle')}
      switchNode={
        <>
          {t('auth.toLogin.q')}
          <Link to="/login">{t('auth.toLogin.link')}</Link>
        </>
      }
    >
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <ErrorBanner message={error} />

        <TextField
          id="fullName"
          label={t('auth.field.fullName')}
          type="text"
          autoComplete="name"
          placeholder={t('auth.field.fullName.ph')}
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          autoFocus
        />

        <TextField
          id="email"
          label={t('auth.field.email')}
          type="email"
          autoComplete="email"
          placeholder={t('auth.field.email.ph')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <PasswordField
          id="password"
          label={t('auth.field.password')}
          autoComplete="new-password"
          placeholder={t('auth.field.password.ph')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label className="auth-terms">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <span>
            {t('auth.terms.prefix')}
            <Link to="/privacy">{t('auth.terms.link')}</Link>
            {t('auth.terms.suffix')}
          </span>
        </label>

        <button type="submit" className="auth-submit" disabled={loading}>
          {loading && <span className="auth-spinner" />}
          {loading ? t('auth.action.signingUp') : t('auth.action.signup')}
        </button>
      </form>
    </AuthShell>
  );
};

export default Signup;
